import { useState, useEffect } from "react";

export const useFilters = (initialItems: any[]) => {
    const [items, setItems] = useState(initialItems);
    const [filters, setFilters] = useState<any>({});
    const [filteredItems, setFilteredItems] = useState(initialItems);

    useEffect(() => {
        applyFilters(filters);
    }, [items, filters]);

    const handleFilterChange = (filterKey: string, value: any) => {
        const newFilters = { ...filters, [filterKey]: value };
        setFilters(newFilters);
    };

    const applyFilters = (activeFilters?: any) => {
        let updatedItems = [...items];
        Object.keys(activeFilters).forEach((key) => {
            const filterValue = activeFilters[key]?.toString().toLowerCase();
            if (filterValue) {
                updatedItems = updatedItems.filter((item: any) =>
                    item[key]?.toString().toLowerCase().includes(filterValue)
                );
            }
        });
        setFilteredItems(updatedItems);
    };

    return { filters, filteredItems, handleFilterChange, setItems };
};